var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[(_vm.isAuthenticated)?_c('div',{ref:_vm.planId,attrs:{"id":_vm.planId}}):_c('div',[_vm._v("Please login to purchase this product.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }